import {fullPath} from 'BenchlingUtil';
import * as BenchlingUtil from 'BenchlingUtil';
import lazyInit from 'util/lazyInit';
import {warn} from 'util/Logging';
import * as net from 'util/Net';

import {defaultVersion, getURLPath, getSpecFilePath} from '../SwaggerUiPage';
import {AvailabilityToShow, AllowedVersions} from './constants';

const BASE_PUBLIC_URL = 'https://benchling.com';
export const DEFAULT_PUBLIC_API_REFERENCE = 'https://benchling.com/api/reference';

export function getBaseURL(): string {
  return BASE_PUBLIC_URL + getURLPath(getVersion(), getAvailability());
}

interface TagOperationShape {
  tagHash: string;
  operationId: string;
}

export function getTagAndOperationFromSystem(
  targetMethod: string,
  targetPath: string,
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  system: any
): TagOperationShape | null {
  const taggedOps = system.specSelectors.taggedOperations();

  for (const tag of taggedOps.values()) {
    for (const operation of tag.get('operations')) {
      if (operation.get('path') === targetPath && operation.get('method') === targetMethod) {
        const tagHash = `#/${tag.get('tagDetails').get('name')}`;
        const operationId = operation.get('operation').get('operationId');
        return {
          tagHash,
          operationId,
        };
      }
    }
  }
  return null;
}

export function getVersion(): string {
  // Gets version from URL if it's of the form /api/<version/reference; otherwise, return default version.
  const path = fullPath();
  const pathList = path.split('/');
  if (pathList.length < 3) {
    warn(`Expected pathname to have at least 2 /'s for path ${path}`);
    return defaultVersion;
  }

  const version = pathList[2];
  if (Object.values(AllowedVersions).includes(version as AllowedVersions)) {
    return version;
  }
  return defaultVersion;
}

export function getAvailability(): AvailabilityToShow {
  const {queryKey} = BenchlingUtil.parseUri(window.location.href);
  return (queryKey.availability as AvailabilityToShow) ?? AvailabilityToShow.GA;
}

export function getSpecUrl(): string {
  return getSpecFilePath(getVersion(), getAvailability());
}

export function buildPublicLinkFromTagOperation(tagOperation: TagOperationShape): string {
  const {tagHash, operationId} = tagOperation;
  const unescapedRoute = `${getBaseURL() + tagHash}/${operationId}`;
  return encodeURI(unescapedRoute);
}

export async function getBearerToken(): Promise<string> {
  const response = await net.postJSONPromise({
    url: '/1/api/bearer-token:create',
    data: {
      bearerTokenConsumer: 'API_DOCS',
    },
  });
  return response.access_token;
}

async function getUserCanUseInteractiveDocs(): Promise<boolean> {
  const response = await net.getJSONPromise('/1/api/enable-interactive-docs');
  return response.enabled;
}

export const lazyGetUserCanUseInteractiveDocs = lazyInit(() => getUserCanUseInteractiveDocs());
